import CancellationSurveyPage from "./components/cancellation-survey-page"
import VueI18n from "vue-i18n"
import store from "@/store/"
import globals from "@/utils/globals"

export default (Vue, { locale }) => {
  const surveyOptions = globals.surveyOptions
  const eligibleForChurnPrevention = globals.churn_prevention
  const isLeavingMup = globals.is_leaving_mup
  const sku = globals.sku
  return new Vue({
    name: "CancellationSurveyPageWrapper",
    store,
    i18n: new VueI18n({ locale }),
    render: (h) => h(CancellationSurveyPage, { props: { surveyOptions, eligibleForChurnPrevention, isLeavingMup, sku } })
  })
}
